import { render, staticRenderFns } from "./HotelPrompt.vue?vue&type=template&id=03bd5f3a&scoped=true&"
import script from "./HotelPrompt.vue?vue&type=script&lang=js&"
export * from "./HotelPrompt.vue?vue&type=script&lang=js&"
import style0 from "./HotelPrompt.vue?vue&type=style&index=0&id=03bd5f3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd5f3a",
  null
  
)

export default component.exports